import styled from 'styled-components';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { spacing, colors, zIndex, easing, fadeIn } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { useTranslations } from '../../../hooks/useTranslations';

const CloseModalOverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${colors.backgroundScreen};
  justify-content: space-between;
  z-index: ${zIndex.modalOverlay};
  animation-duration: 200ms;
  animation-fill-mode: forwards;
  animation-name: ${fadeIn};
  animation-timing-function: ${easing.entrance};
  border-radius: ${spacing.threeQuarter};
`;

const BottomActionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing.half};
  background: ${colors.backgroundPrimary};
  border-top: 1px solid ${colors.borderPrimary};
  border-radius: 0 0 ${spacing.threeQuarter} ${spacing.threeQuarter};
  padding: ${spacing.plusHalf};
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
`;

const ActionText = styled.div`
  color: ${colors.textPrimary};
  font-size: ${pxToRem(14)};
  font-weight: 400;

  & > span {
    color: ${colors.textSecondary};
  } 
`;

const ActionButtons = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const CloseModalOverlay = ({
  onCancel,
  onConfirm,
}: { onCancel: () => void; onConfirm: () => void }) => {
  const { t } = useTranslations();
  return (
    <CloseModalOverlayContainer>
      <BottomActionBar>
        <ActionText>
          <strong>{t('caption.confirmUploadCloseModal')}</strong>{' '}
          <span>{t('caption.closeUploadDiscard')}</span>
        </ActionText>
        <ActionButtons>
          <Button onClick={onCancel} size={BUTTON_SIZES.LARGE} variant={BUTTON_VARIANTS.SECONDARY}>
            {t('button.keepEditing')}
          </Button>
          <Button
            onClick={onConfirm}
            size={BUTTON_SIZES.LARGE}
            variant={BUTTON_VARIANTS.DESTRUCTIVE}
          >
            {t('button.closeAndDiscard')}
          </Button>
        </ActionButtons>
      </BottomActionBar>
    </CloseModalOverlayContainer>
  );
};
